module.exports = __webpack_public_path__ + "img/icon_coi_detail.27612ace.png";